module.exports = __webpack_public_path__ + "static/media/footer-bg.9e04c9c3.jpg";